module.exports = __webpack_public_path__ + "assets/img/advantage4.fb6cde44.png";